import { Autocomplete, Button, FormControl, Grid, TextField } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';




interface DataItem {
  date: string;
  pf: number | null;
  pe: number | null;
  af: number | null;
  ae: number | null;
}


const GraficaBarras: React.FC = () => {
  const [datos, setDatos] = useState<DataItem[]>([{
    date: "",
    pf: null,
    pe: null,
    af: null,
    ae: null
  }]);

  const [interval, setInterval] = useState([]);      // [{value, label}]
  const [selected, setSelected] = useState(null);

  const getDatos = async (filtro?: string) => {
    try {
      var url = process.env.REACT_APP_APPLICATION_ENDPOINT + "/public/consulta/grafica";
      if (filtro) { url = url + "?periodo=" + filtro; }
      const response = await axios.get(url);
      const data = response.data.data;
      setInterval(response.data.interval);

      if (data.length > 0) {
        // Reemplazar valores 0 por null para cortar la línea
        const dataTransformada = data.map((item: DataItem) => ({
          ...item,
          pf: item.pf === 0 ? null : item.pf,
          pe: item.pe === 0 ? null : item.pe,
          af: item.af === 0 ? null : item.af,
          ae: item.ae === 0 ? null : item.ae,
        }));

        setDatos(dataTransformada);
      }

    } catch (error) {
      console.error("Error obteniendo los periodos:", error);
    }
  };
  useEffect(() => {
    getDatos();
  }, []);

  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');

  const years = Array.from(
    new Set(interval.map((i: any) => i.value.split('-')[0]))
  );

  const months = interval
    .filter((i: any) => i.value.startsWith(year))
    .map((i: any) => {
      const [y, m] = i.value.split('-');
      return { value: m, label: i.label.split(' ')[0] };
    });

  const filtrar = () => {
    if (!year || !month) return;
    const value = `${year}-${month}`;
    getDatos(value); // aquí llamas tu acción
  };

  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);

  // Detecta cambio de tamaño de pantalla
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ width: '100%' , height:"500px" }}>
      <ResponsiveContainer width="100%" height="80%">
        <LineChart
          data={datos}
          margin={{ top: 20, right: 30, left: 20, bottom: 70 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            interval={0}
            tick={({ x, y, payload }) => (
              <text
                x={x}
                y={y}
                dy={16}
                fill="#666"
                fontSize={12}
                textAnchor="end"
                transform={`rotate(-45, ${x}, ${y})`}
              >
                {payload.value}
              </text>
            )}
          />
          <YAxis
            tick={{ fontSize: 11 }}
            tickFormatter={(value) => {
              if (value >= 1_000_000) {
                return `${(value / 1_000_000).toLocaleString()}M`;
              }
              return value.toLocaleString();
            }}
          />
          <Tooltip formatter={(value) => value.toLocaleString()} />
          <Legend
            verticalAlign="top"
            height={isMobile ? 140 : 60}
            layout={isMobile ? 'vertical' : 'horizontal'}
            align="center"
            wrapperStyle={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              justifyContent: 'center',
              alignItems: isMobile ? 'flex-start' : 'center',
              gap: isMobile ? 4 : 24,
            }}
          />
          <Line type="monotone" dataKey="pf" stroke="#FE8304" name="Participaciones Federales" dot />
          <Line type="monotone" dataKey="pe" stroke="#28CD7E" name="Participaciones Estatales" dot />
          <Line type="monotone" dataKey="af" stroke="#48ABFF" name="Aportaciones Federales" dot />
          <Line type="monotone" dataKey="ae" stroke="#8085D6" name="Aportaciones Estatales" dot />
        </LineChart>
      </ResponsiveContainer>
      <Grid container spacing={2}>
        {/* AÑO */}
        <Grid item xs={12} md={4}>
          <FormControl fullWidth size="small">
            <Autocomplete
              options={years}
              value={year || null}
              onChange={(_, value) => {
                setYear(value || '');
                setMonth('');
              }}
              noOptionsText="Sin opciones"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Año"
                  size="small"
                  sx={{
                    '& .MuiInputBase-root': { height: 50 },
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>

        {/* MES */}
        <Grid item xs={12} md={4}>
          <FormControl fullWidth size="small">
            <Autocomplete
              options={months}
              getOptionLabel={(option) => option.label}
              value={months.find(m => m.value === month) || null}
              onChange={(_, value) => setMonth(value?.value || '')}
              noOptionsText="Sin opciones"
              disabled={!year}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Mes"
                  size="small"
                  sx={{
                    '& .MuiInputBase-root': { height: 50 },
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>

        {/* BOTÓN */}
        <Grid item xs={12} md={4}>
          <Button
            fullWidth
            variant="contained"
            onClick={filtrar}
            sx={{
              height: 50,
              backgroundColor: '#FE8304',
              '&:hover': { backgroundColor: '#e67600' }
            }}
          >
            Filtrar
          </Button>
        </Grid>
      </Grid>



    </div>
  );
}
export { GraficaBarras };